import { useEffect, useState } from "react";
import { Button, DinamicInput, Input, InputOdontograma, Switchi } from "../../components/Form";
// import TwoColumRow from "../../components/TwoColumRow";
import { useForm } from "react-hook-form";
import { useDispatch } from "react-redux";
import {
  createEstudios,
  getEstudiosByCitaId,
  updateEstudios,
} from "../../redux/features/estudiosSlice";
import toast from "react-hot-toast";
import { FaTimes } from "react-icons/fa";
import MultipleUploader from "../../components/MultipleUploader";
import { FileIcon } from "../../components/FileIcon";
import { Switch } from "@headlessui/react";
import TwoColumnRowConditional from "../../components/TwoColumnRowConditional";
import { useViewType } from "../../utils/ViewState";

const laboratorioLabels = [
  "Glicemia",
  "Tiempo de coagulación",
  "Tiempo de sangría",
  "Hemograma completo",
  "Hemoglobina - Hematocrito",
  "Urea",
  "Creatinina",
  "Colesterol Total",
  "LDH",
  "Acido Úrico",
  "Hemoglobina Glicosilada",
  "Eritrosedimentacion",
  "Grupo Sanguíneo y factor RH",
  "T. de Protombina(TP)",
  "T. Tromboplastina P. Activada (TTPA)",
  "Recuento de Plaquetas",
  "Orina Completa",
  "Proteinuria en Orina",
  "Glicemia Post Prandial",
  "Curva de Tolerancia a la glicemia",
  "HDL Colesterol",
  "LDL Colesterol",
  "Triglicéridos",
  "Bilirrubinas",
  "GOT - Transaminasa",
  "GPT - Transanaminasa",
  "Fosfatasa Alcalina",
  "GGT",
  "Amilasa",
  "Proteinas Totales",
  "Albuminas",
  "Calcio Ionico",
  "Fósforo",
  "Magnesio",
  "Sodio",
  "Potasio",
  "Troponina I",
  "Hierro Sérico",
  "Ferritina",
  "Transferrina",
  "% de Saturación",
  "Vitamina B12",
  "Vitamina D25",
  "PCR",
  "Chagas IFI Ig G. lg M",
  "Chagas HAI",
  "PSA",
  "T3",
  "TSH",
  "T4 Libre"
];

const laboratorioKeys = [
  'glicemia',
  'tiempo_coagulacion',
  'tiempo_sangria',
  'hemograma_completo',
  'hemoglobina_hematocrito',
  'urea',
  'creatinina',
  'colesterol_total',
  'ldh',
  'acido_urico',
  'hemoglobina_glicosilada',
  'eritrosedimentacion',
  'grupo_sanguineo_y_factor_rh',
  't_de_protombina_tp',
  't_tromboplastina_p_activada_ttpa',
  'recuento_de_plaquetas',
  'orina_completa',
  'proteinuria_en_orina',
  'glicemia_post_prandial',
  'curva_de_tolerancia_a_la_glicemia',
  'hdl_colesterol',
  'ldl_colesterol',
  'trigliceridos',
  'bilirrubinas',
  'got_transaminasa',
  'gpt_transaminasa',
  'fosfatasa_alcalina',
  'ggt',
  'amilasa',
  'proteinas_totales',
  'albuminas',
  'calcio_ionico',
  'fosforo',
  'magnesio',
  'sodio',
  'potasio',
  'troponina_i',
  'hierro_serico',
  'ferritina',
  'transferrina',
  'porcentaje_de_saturacion',
  'vitamina_b12',
  'vitamina_d25',
  'pcr',
  'chagas_ifi_ig_g_lg_m',
  'chagas_hai',
  'psa',
  't3',
  'tsh',
  't4_libre'
];

const Laboratorio = ({ data, onClose }) => {
  const [archivos, setArchivos] = useState(null);
  const [files, setFiles] = useState([]);
  const { register, handleSubmit, setValue } = useForm();

  const [values, setValues] = useState(
    laboratorioKeys.reduce((acc, key) => {
      acc[key] = false;
      return acc;
    }, {})
  );

  // const [inputValues, setInputValues] = useState(
  //   laboratorioKeys.reduce((acc, key) => {
  //     acc[key] = "";
  //     return acc;
  //   }, {})
  // );

  const [valueSearch, setValueSearch] = useState("");
  const [filtered, setFiltered] = useState([]);

  const handleSearch = (e) => {
    setValueSearch(e.target.value);
    setFiltered(laboratorioLabels.filter(value => 
      value.toLowerCase().includes(e.target.value.toLowerCase())
    ));
  };

  useEffect(() => {
    // Convierte los nombres de las claves a minúsculas y reemplaza los espacios por _
    const formattedData = Object.keys(data).reduce((acc, key) => {
      acc[key.toLowerCase().replace(/\s+/g, "_").replace(/[().,-]/g, "")] = data[key];
      return acc;
    }, {});
    setArchivos(data.archivos);

    // Inicializa el estado de valores y valores de entrada con los datos del objeto
    setValues(
      laboratorioKeys.reduce((acc, key) => {
        acc[key] = formattedData[key] === 1;
        return acc;
      }, {})
    );

    laboratorioKeys.forEach((key) => {
      setValue(
        "resultado_" + key,
        formattedData["resultado_" + key] || ""
      );
    });
  }, [data, setValue]);

  const handleSwitchChange = (label) => (checked) => {
    const key = laboratorioKeys[laboratorioLabels.indexOf(label)];
    setValues((prevValues) => ({
      ...prevValues,
      [key]: checked,
    }));
  };

  const handleKeyOfLabel = (label) => {
    return values[laboratorioKeys[laboratorioLabels.indexOf(label)]];
  }

  const dispatch = useDispatch();

  const onSubmit = async (body) => {
    Object.keys(values).forEach((key) => {
      body[key.toLowerCase()] = values[key];
    });
    body.cita_id = data?.cita_id;
    body.tipo = data?.tipo;
    body.archivos = archivos;
    body.files = files;
    let res = null;
    if (data?.id) {
      body.id = data?.id;
      res = await dispatch(updateEstudios(body));
    } else {
      res = await dispatch(createEstudios(body));
    }

    if (res?.error) {
      toast.error("No se pudo guardar la orden: " + res.error);
    } else {
      setFiles([]);
      toast.success("Orden Guardada con exito!");
      dispatch(getEstudiosByCitaId(data.cita_id));
      onClose();
    }
  };

  const deleteFile = (index) => {
    setFiles(files.filter((file, i) => index !== i));
  };

  return (
    <>
      <div className="h-96 overflow-y-scroll border px-5 mb-5 pb-5 rounded-lg">
        <InputOdontograma
          name={"buscador_analisis"}
          label={"Buscar analisis"}
          color={true}
          register={register("pieza", {
            onChange: (e) => handleSearch(e),
          })}
          disabled={false}
          placeholder={"Buscar analisis"}
          className="top-10 bottom-10 w-full"
        />
        {/* {filtered?.length > 0 && (
          <ul className="max-h-40 border absolute rounded-lg z-50 bg-white overflow-y-scroll">
            {filtered?.map((item) => (
            <li
              key={item.id}
              onMouseDown={() => {
                setValueSearch(item.name);
              }}
              className="border-b py-2 px-5"
            >
              {`${item}`}
            </li>
            ))}
          </ul>
          )} */}
        {
          valueSearch ? (
            filtered.map((label, index) => {
              const key = laboratorioKeys[laboratorioLabels.indexOf(label)];
              return key ? (
                <div key={index} className={"flex "}>
                  <TwoColumnRowConditional className="flex w-2/3 pt-6">
                    <Switch
                      checked={handleKeyOfLabel(label)}
                      onChange={handleSwitchChange(label)}
                      className={`${handleKeyOfLabel(label) ? "bg-subMain" : "bg-border"}
                      relative inline-flex p-[2px] w-12 cursor-pointer rounded-full transitions flex-shrink-0`}
                    >
                      <span
                        aria-hidden="true"
                        className={`${handleKeyOfLabel(label) ? "translate-x-5" : "translate-x-0"}
                        pointer-events-none inline-block h-6 w-6 transform rounded-full bg-white shadow-lg  transitions`}
                      />
                    </Switch>
                    <label>{label}</label>
                    
                    <Input
                      color={handleKeyOfLabel(label) && true}
                      register={register('resultado_' + key)}
                      disabled={!handleKeyOfLabel(label)}
                    />
                  </TwoColumnRowConditional>
                </div>
              ) : (
                <div className="w-full bg-text rounded-lg flex justify-center items-center">
                  <span className="text-gray-500">No se encontraron resultados</span>
                </div>
              );
            })
          ) : (
            laboratorioLabels.map((label, index) => {
              const key = laboratorioKeys[laboratorioLabels.indexOf(label)];
              return (
                <div key={index} className={"flex "}>
                  <TwoColumnRowConditional className="flex w-2/3 pt-6">
                    <Switch
                      checked={handleKeyOfLabel(label)}
                      onChange={handleSwitchChange(label)}
                      className={`${handleKeyOfLabel(label) ? "bg-subMain" : "bg-border"}
                      relative inline-flex p-[2px] w-12 cursor-pointer rounded-full transitions flex-shrink-0`}
                    >
                      <span
                        aria-hidden="true"
                        className={`${handleKeyOfLabel(label) ? "translate-x-5" : "translate-x-0"}
                        pointer-events-none inline-block h-6 w-6 transform rounded-full bg-white shadow-lg  transitions`}
                      />
                    </Switch>
                    <label>{label}</label>
                    
                    <Input
                      color={handleKeyOfLabel(label) && true}
                      register={register('resultado_' + key)}
                      disabled={!handleKeyOfLabel(label)}
                    />
                  </TwoColumnRowConditional>
                </div>
              );
            })
          )
        }
      </div>
      {archivos?.length > 0 && (
        <div>
          <h2>Archivos adjuntos</h2>
          <table className="min-w-full divide-y divide-gray-200">
            <thead className="bg-gray-50">
              <tr>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                  Nombre
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                  Archivo
                </th>
              </tr>
            </thead>
            <tbody className="bg-white divide-y divide-gray-200">
              {archivos.split(",").map((file, index) => (
                <tr key={index}>
                  <td className="px-6 py-4 whitespace-nowrap">
                    <div className="text-sm text-gray-900">
                      {file.split("/")?.at(-1)}
                    </div>
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap">
                    <a
                      href={file}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-subMain"
                    >
                      <span className="mr-2 inline-block">
                        <FileIcon extension={file.split(".").pop()} />
                      </span>
                      Descargar
                    </a>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
      <div className="flex gap-3 flex-col w-full col-span-6 my-2">
        <p className="text-sm">Archivos Adjuntos</p>
        <div className="grid xs:grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-4 w-full">
          {files.length > 0 &&
            files.map((file, i) => (
              <div className="relative w-full">
                <img
                  src={file?.preview}
                  alt={file.name}
                  className="w-full  md:h-40 rounded-lg object-cover mt-5 p-1"
                  key={i}
                />
                <button
                  onClick={() => deleteFile(i)}
                  className="bg-white rounded-full w-8 h-8 flex-colo absolute -top-1 -right-1"
                >
                  <FaTimes className="text-red-500" />
                </button>
              </div>
            ))}
        </div>

        <MultipleUploader
          setFile={setFiles}
          file={files}
          title="Arrastre sus archivos aqui"
          placeholder="Solo se aceptan archivos tipo imagen y documento"
        />
      </div>
      <Button label="Guardar" onClick={handleSubmit(onSubmit)} />
    </>
  );
};

export default Laboratorio;